// Libs
import { createSlice } from '@reduxjs/toolkit';
// Others
import { RootState } from '~/utils/redux/store';
import {
  getEstimateTemplateList,
  createEstimateTemplate,
  deleteEstimateTemplate,
  updateEstimateTemplate,
  getEstimateTemplateDetails,
} from '~/thunks/estimateTemplate/estimateTemplateThunk';

export interface IEstimateTemplateState {
  isRefreshEstimateTemplateList: boolean;
}

export const initialState: IEstimateTemplateState = {
  isRefreshEstimateTemplateList: false,
};

const estimateTemplateSlice = createSlice({
  name: 'estimateTemplate',
  initialState,
  reducers: {
    setRefreshEstimateTemplateList(state, action) {
      state.isRefreshEstimateTemplateList = action.payload;
    },
  },
  extraReducers: (builder) => {
    // POST: Create estimate template
    builder
      .addCase(createEstimateTemplate.pending, (_state) => {})
      .addCase(createEstimateTemplate.fulfilled, (_state) => {})
      .addCase(createEstimateTemplate.rejected, (_state) => {});

    // GET: Get estimate template list
    builder
      .addCase(getEstimateTemplateList.pending, (_state) => {})
      .addCase(getEstimateTemplateList.fulfilled, (_state) => {})
      .addCase(getEstimateTemplateList.rejected, (_state) => {});

    // DELETE: Delete estimate template
    builder
      .addCase(deleteEstimateTemplate.pending, (_state) => {})
      .addCase(deleteEstimateTemplate.fulfilled, (_state) => {})
      .addCase(deleteEstimateTemplate.rejected, (_state) => {});

    // PUT: Update estimate template
    builder
      .addCase(updateEstimateTemplate.pending, (_state) => {})
      .addCase(updateEstimateTemplate.fulfilled, (_state) => {})
      .addCase(updateEstimateTemplate.rejected, (_state) => {});

    // GET: Get estimate template details
    builder
      .addCase(getEstimateTemplateDetails.pending, (_state) => {})
      .addCase(getEstimateTemplateDetails.fulfilled, (_state) => {})
      .addCase(getEstimateTemplateDetails.rejected, (_state) => {});
  },
});

// Action
export const estimateTemplateActions = estimateTemplateSlice.actions;

// Selectors
export const selectIsRefreshEstimateTemplateList = (state: RootState) =>
  state.estimateTemplate.isRefreshEstimateTemplateList;

// Reducer
const estimateTemplateReducer = estimateTemplateSlice.reducer;
export default estimateTemplateReducer;
